<template>
  <div class="main-jobs">
    <div class="margin-top-30"></div>
    <jobs-list />
  </div>
</template>

<script>
import Route from "vue-router";
import JobsList from "~/components/jobs/JobsList.vue";
import { mapState } from "vuex";

import axios from "axios";
// Define a standalone function
async function fetchData(store, params, query) {
  const isMobile = store.state.isMobile;

  let state = "";
  let city = "";

  if (query.location) {
    const locationParts = query.location.split(",");
    if (locationParts.length === 2) {
      city = locationParts[0].trim();
      state = locationParts[1].trim();
    } else if (locationParts.length === 1) {
      state = locationParts[0].trim();
    }
  }

  const qstring = {
    mainCategory: params.mainCategory || "",
    category: params.category || "",
    state: state,
    city: city,
    isMobile: isMobile,
    type: query.type
  };

  await store.dispatch("jobs/getJobsQueryString", {
    qstring: { qstring },
    route: { params, query }, // Construct a route-like object
  });
}


export default {
  data: function () {
    return {
      mainCategory: this.$route.params.mainCategory,
      category: this.$route.params.category,
    };
  },

  computed: {
    ...mapState("jobs", {
      metaTags: (state) => state.metaTags,
    }),
  },

  components: {
    JobsList,
  },

  async asyncData({ app, params, store, $sentry }) {
    if (process.server) {
      // Server-side logic{
      try {
        await fetchData(store, params, app.context.route.query);
      } catch (error) {
        $sentry.captureException(error)
      }
    }
  },

  async mounted() {
    if (process.client && !this.$store.state.jobs.isJobsListingsLoaded) {
      // Client-side logic
      try {
        await fetchData(this.$store, this.$route.params, this.$route.query);
      } catch (error) {
        this.$handleExceptionWithSentry(error);
      }
    }
  },

  beforeDestroy() {
    // Reset the flag when leaving the page
    this.$store.commit('jobs/destroyJobsListings');
  },

  head() {
    return {
      title: this.metaTags.title,
      link: [{ rel: "canonical", href: this.metaTags.canonical }],
      meta: this.createMetaTags(this.metaTags)

    };
  },

};



</script>
